// Technologies and languages icons
import HTMLIcon from "../assets/img/HTML.webp";
import CSSIcon from "../assets/img/CSS.webp";
import SASSIcon from "../assets/img/SASS.webp";
import JavascriptIcon from "../assets/img/Javascript.webp";
import TypescriptIcon from "../assets/img/Typescript.webp";
import ReactIcon from "../assets/img/React.webp";
import NodeJsIcon from "../assets/img/NodeJs.webp";
import ExpressJsIcon from "../assets/img/ExpressJs.webp";

const TechnologiesList = [
    {
        id: 1,
        icon: HTMLIcon,
        name: "HTML",
        delay: 0,
    },
    {
        id: 2,
        icon: CSSIcon,
        name: "CSS",
        delay: .2,
    },
    {
        id: 3,
        icon: SASSIcon,
        name: "SASS",
        delay: .4,
    },
    {
        id: 4,
        icon: JavascriptIcon,
        name: "Javascript",
        delay: .6,
    },
    {
        id: 5,
        icon: TypescriptIcon,
        name: "Typescript",
        delay: .8,
    },
    {
        id: 6,
        icon: ReactIcon,
        name: "React",
        delay: 1,
    },
    {
        id: 7,
        icon: NodeJsIcon,
        name: "Node JS",
        delay: 1.2,
    },
    {
        id: 8,
        icon: ExpressJsIcon,
        name: "Express JS",
        delay: 1.4,
    },
];

export default TechnologiesList;